import AwardItem from './case-awards-items/award-item';
import { TYPE_AWARDS } from '@/utils/case-types';

export default class CaseAwards {
  constructor(data) {
    this.items = [];
    this.type = TYPE_AWARDS;
    // Initialize data
    if (data) {
      Object.assign(this, {
        items: data.Items ? data.Items.map((item) => new AwardItem(item)) : []
      });
    }
  }
}



// WEBPACK FOOTER //
// src/entities/case/case-awards.js